module.exports = {
    controller: 'searchBoxController',
    templateUrl: 'search/components/header-search-box.html'
};